import {
  type LeadsListListData,
  type PaginatedDropdownList,
  type ReturnUserReadable,
  type UsersListListData,
  leadsListListInfiniteOptions,
  ReturnLeadReadable,
  usersListListInfiniteOptions
} from '@crm/api'
import { InfiniteSelect } from '@crm/components'
import { useQueryUpdate } from '@shared/hooks'
import { defaultFilters, getMultipleParamsValues } from '@shared/utils'
import { useTranslation } from 'react-i18next'

export const ContactFilters = () => {
  const { params, updateQuery } = useQueryUpdate()

  const { t } = useTranslation()

  return (
    <>
      <InfiniteSelect<
        LeadsListListData,
        PaginatedDropdownList,
        ReturnLeadReadable
      >
        getQueryFunction={leadsListListInfiniteOptions}
        placeholder={t('filter.leads')}
        baseOptions={{
          query: {
            preference: params?.leads ? [params.leads] : []
          }
        }}
        onChange={(leads) => updateQuery({ leads, page: defaultFilters.page })}
        value={getMultipleParamsValues(params.leads)}
        mode="multiple"
        maxTagCount={1}
        className="select-min-width"
      />

      <InfiniteSelect<
        UsersListListData,
        PaginatedDropdownList,
        ReturnUserReadable
      >
        getQueryFunction={usersListListInfiniteOptions}
        onChange={(created_by) =>
          updateQuery({ created_by, page: defaultFilters.page })
        }
        placeholder={t('task.created_by')}
        baseOptions={{
          query: {
            preference: params?.created_by ? [params.created_by] : []
          }
        }}
        value={params?.created_by || undefined}
        className="select-min-width"
      />
    </>
  )
}
